export default __webpack_public_path__ + "assets/0fc9e20a2681232b4af3241a41ad210c.png";